import update from "immutability-helper/index";
import {FETCHED_OVERVIEW_FEATURES} from "./types";

const INITIAL_STATE = {
    allOverviewFeatures: [],
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {

        case FETCHED_OVERVIEW_FEATURES:
            let features = action.payload.features;

            return update(state, {
                allOverviewFeatures: {$set : features }
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/overview/reducer.js